
import { initialReadingState, IReadingState } from "@edp-store/state/reading.state";
import { EReadingActions, ReadingActions } from "@edp-store/actions/reading.actions";

export function readingReducers(
    state = initialReadingState,
    action: ReadingActions
): IReadingState {
    switch (action.type) {
        case EReadingActions.SetReadings: {
            return {
                ...state,
                readings: action.readings
            };
        }
        case EReadingActions.SetUploadReadingElectricity: {
            return {
                ...state,
                uploadReadingElectricity: action.reading
            };
        }
        case EReadingActions.SetUploadReadingGas: {
            return {
                ...state,
                uploadReadingGas: action.reading
            };
        }
        default: {
            return state;
        }
    }
}
